import React, { useEffect, useState } from "react";
import $ from "jquery";
import Icon from "../base/Icon";
import FlexRow from "../base/FlexRow";
import DateItem, { RangeDateItem } from "../../models/DateItem";
import { FontAwesomeIcons } from "src/core/Types";
import { usePreferences } from "../../core/Global";
import { DateFormats, TimeFormats } from "../../core/Enums";
import moment from "moment";

export interface DatePickItem {
    date: any
    endDate: any
    value: string
    startVal: string
    endVal: string
}

interface DatePickerProps {
    id: string
    label?: string
    labelUp?: boolean
    block?: boolean
    name?: string
    small?: boolean
    solid?: boolean
    reset?: boolean
    autoFocus?: boolean

    selectedDate?: string
    selectedDateItem?: DateItem
    selectedDateItems?: DateItem[]
    selectedRangeDates?: RangeDateItem[]

    date?: Date
    dateOffset?: number

    minDate?: Date
    maxDate?: Date

    noTextError?: boolean
    empty?: boolean
    marginBottom?: number
    parentId?: string
    dateType?: "birthdate" | "range" | "single"
    timePicker?: boolean
    inlineMultipleDates?: boolean
    placeholder?: string
    icon?: FontAwesomeIcons
    drops?: "down" | "up" | "auto"
    preventClear?: boolean
    onPick?: (e: DatePickItem) => void
    onClear?: () => void
}



export default function DatePicker(props: DatePickerProps) {

    const pref = usePreferences()
    const [format, formatSet] = useState<string>();
    const [formatVal, formatValSet] = useState<string>();
    const [selectedDate, selectedDateSet] = useState<any>();
    const [selectedDateString, selectedDateStringSet] = useState<string>("");
    const [selectedDateValString, selectedDateValStringSet] = useState<string>("");
    const [selectedStartDateString, selectedStartDateStringSet] = useState<string>("");
    const [selectedEndDateString, selectedEndDateStringSet] = useState<string>("");
    const [dp, dpSet] = useState<any>();

    const [pickedItem, pickedItemSet] = useState<DatePickItem>();
    const [multipleSelectedDates, multipleSelectedDatesSet] = useState<DatePickItem[]>([]);

    useEffect(() => {
        if (!pref?.systemPreferences) return;

        var frm = "DD/MM/YYYY";
        var frmVal = "DD/MM/YYYY";

        if (pref?.systemPreferences.dateFormat == DateFormats.MMDDYYYY) frm = "MM/DD/YYYY";
        if (pref?.systemPreferences.dateFormat == DateFormats.DDMMM) frm = "DD MMM YYYY";

        if (props.timePicker) {
            if (pref?.systemPreferences.timeFormat == TimeFormats.Format24Hours) frm += " HH:mm";
            else frm += " hh:mm a";
            frmVal += " HH:mm";
        }

        formatSet(frm);
        formatValSet(frmVal);

    }, [pref, props.timePicker])

    const [multipeExistsErr, multipeExistsErrSet] = useState<number>(-1);
    useEffect(() => {
        if (multipeExistsErr > -1) {
            setTimeout(() => {
                multipeExistsErrSet(-1);
            }, 500);
        }
    }, [multipeExistsErr])

    const className = () => {
        var cls = "form-control form-inputs kt_daterangepicker";
        if (props.small) cls += " form-control-sm";
        if (props.solid) cls += " form-control-solid";
        if (props.autoFocus) cls += " auto-focus";
        return cls;
    }

    const inputGroupClassName = () => {
        var cls = "input-group";
        if (props.small) cls += " input-group-sm";
        if (props.solid) cls += " input-group-solid";
        return cls;
    }

    useEffect(() => {

        var opt: any = {};

        if (props.minDate) opt.minDate = moment(props.minDate);
        if (props.maxDate) opt.maxDate = moment(props.maxDate);
        if (props.drops) opt.drops = props.drops;
        if (props.timePicker) {
            opt.timePicker = true;
        }
        if (!props.dateType || props.dateType == "birthdate" || props.dateType == "single") {
            opt.autoApply = true;
            opt.singleDatePicker = true;
        }
        else {
            opt.autoApply = false;
            opt.singleDatePicker = false;
        }

        var d = window.datepicker(props.id, opt);

        dpSet(d);

        //if (props.onDatePicked) props.onDatePicked(val, date);
        //bindedSet(true);

    }, []);

    useEffect(() => {
        if (dp) {
            dp.on('apply.daterangepicker', function (e: any, p: any) {

                var dateVal = p.startDate.format(formatVal)
                var dateText = p.startDate.format(format)

                if (props.dateType == "range") {
                    dateVal += " - " + p.endDate.format(formatVal);
                    dateText += " - " + p.endDate.format(format);
                }

                var pickItem: DatePickItem = {
                    date: p.startDate,
                    endDate: p.endDate,
                    value: dateVal,
                    startVal: p.startDate.format(formatVal),
                    endVal: p.endDate.format(formatVal)
                }

                if (props.dateType == "range") {
                    selectedStartDateStringSet(p.startDate.format(format));
                    selectedEndDateStringSet(p.endDate.format(format));
                }

                selectedDateStringSet(dateText);
                selectedDateValStringSet(dateVal);
                pickedItemSet(pickItem);
            });
        }
    }, [dp])

    useEffect(() => {
        if (pickedItem) {

            if (props.inlineMultipleDates) {
                var arr = multipleSelectedDates ?? [];
                var exists = -1;
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].value == pickedItem.value) {

                        exists = i;
                        break;
                    }
                }

                if (exists > -1) {
                    multipeExistsErrSet(exists);
                }
                else {
                    arr.push(pickedItem);
                    multipleSelectedDatesSet(a => [...arr]);
                }
            }

            if (props.onPick) props.onPick(pickedItem)

            if (props.inlineMultipleDates) {
                dp.data('daterangepicker').setStartDate(window.now().hours(0).minutes(0).seconds(0).milliseconds(0));
                dp.data('daterangepicker').setEndDate(window.now().hours(0).minutes(0).seconds(0).milliseconds(0));
            }


        }
    }, [pickedItem])

    useEffect(() => {
        if (props.selectedDateItems && props.inlineMultipleDates) {
            var arr = multipleSelectedDates ?? [];
            props.selectedDateItems.forEach(s => {
                arr.push({
                    date: window.parseToDate(s.text ?? ""),
                    endDate: window.now(),
                    value: s.text ?? "",
                    startVal: s.text ?? "",
                    endVal: ""
                });
            });

            multipleSelectedDatesSet(a => [...arr]);
        }
    }, [props.selectedDateItems, props.inlineMultipleDates])

    useEffect(() => {
        if (props.selectedRangeDates && props.inlineMultipleDates && props.dateType == "range") {
            var arr = multipleSelectedDates ?? [];
            props.selectedRangeDates.forEach(s => {
                arr.push({
                    date: window.parseToDateTime(s.startDate?.text ?? ""),
                    endDate: window.parseToDateTime(s.endDate?.text ?? ""),
                    value: s.text ?? "",
                    startVal: s.startDate?.text ?? "",
                    endVal: s.endDate?.text ?? ""
                });
            });
            multipleSelectedDatesSet(a => [...arr]);
        }
    }, [props.selectedRangeDates, props.inlineMultipleDates])


    useEffect(() => {
        if (props.minDate && dp) {
            dp.data('daterangepicker').minDate = moment(props.minDate);
        }
    }, [props.minDate, dp])

    useEffect(() => {
        if (props.maxDate && dp) {
            dp.data('daterangepicker').maxDate = moment(props.maxDate);
        }
    }, [props.maxDate, dp])


    useEffect(() => {

        if (!format) return;
        if (!dp) return;

        if (props.date && moment(props.date).year() > 1900) {
            //console.log("default date 1", props.date)
            var dt = moment(props.date);
            if (props.dateOffset) dt = moment(props.date).utc().add(props.dateOffset, "minutes");
            selectedDateStringSet(dt.format(format));
            selectedDateValStringSet(dt.format(formatVal));
            selectedDateSet(dt);
        }
        else if (props.selectedDateItem?.text) {
            //console.log("default date 2", props.selectedDateItem)
            selectedDateStringSet(props.selectedDateItem.text);
            selectedDateValStringSet(props.selectedDateItem.text);
            selectedDateSet(window.parseToDate(props.selectedDateItem.text));
        }
        else if (props.selectedDate) {
            //console.log("default date 3", props.selectedDate)
            if (props.selectedDate.includes("-")) {
                var dateArr = props.selectedDate.split("-")
                var from = moment(dateArr[0], formatVal)
                var to = moment(dateArr[1], formatVal)
                selectedDateStringSet(moment(from).format(format) + " - " + moment(to).format(format))
                selectedDateValStringSet(moment(from).format(formatVal) + " - " + moment(to).format(formatVal))
            }
            else {
                var datestr = props.selectedDate;
                var dateobj = moment(datestr, formatVal);
                selectedDateStringSet(moment(dateobj).format(format));
                selectedDateValStringSet(datestr);
                selectedDateSet(dateobj);
            }

        }
        else {
            //console.log("default date 4", window.now().hours(0).minutes(0).seconds(0).milliseconds(0))
            selectedDateSet(window.now().hours(0).minutes(0).seconds(0).milliseconds(0));
            selectedDateStringSet("");
            selectedDateValStringSet("");
        }

    }, [format, dp, props.date]);

    useEffect(() => {
        if (dp && selectedDate) {
            dp.data('daterangepicker').setStartDate(selectedDate);
            dp.data('daterangepicker').setEndDate(selectedDate);
        }
    }, [selectedDate, dp])

    useEffect(() => {
        if (props.reset) {
            selectedDateSet(window.now());
            selectedDateStringSet("");
            selectedDateValStringSet("");
            //window.datepickerClear(props.id);
        }
    }, [props.reset])

    useEffect(() => {
        window.hideFormError(props.name, props.parentId);
    }, [selectedDateString])

    return (
        <>
            {
                props.inlineMultipleDates ?
                    <FlexRow className={"mb-" + (props.marginBottom ?? 5)} wrap>
                        {
                            multipleSelectedDates.map((d, k) =>
                                <span key={k} className={"btn btn-outline badge-multiple-date me-1 mb-1" + (multipeExistsErr == k ? " badge-multiple-date-blink" : " badge-multiple-date-blink-off")}>
                                    <span className="fs-9 me-2">
                                        {d.value}
                                    </span>
                                    <a href="#" className="text-dark"
                                        onClick={e => {
                                            e.preventDefault();
                                            var arr = multipleSelectedDates ?? [];
                                            arr.splice(k, 1);
                                            multipleSelectedDatesSet(a => [...arr]);
                                        }}>
                                        <Icon icon="times" size={11} />
                                    </a>

                                    {
                                        props.dateType == "range" ?
                                            <>
                                                <input type="hidden" name={(props.name ?? "date") + "Start" + k} value={d.date.format("DD/MM/YYYY HH:mm")} />
                                                <input type="hidden" name={(props.name ?? "date") + "End" + k} value={d.endDate.format("DD/MM/YYYY HH:mm")} />
                                            </>
                                            :
                                            <input type="hidden" name={(props.name ?? "date") + k} value={d.date.format("DD/MM/YYYY")} />
                                    }


                                </span>
                            )
                        }
                        <span id={props.id} className={"btn btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark btn-multiple-date "}>
                            <Icon icon="plus" size={10} />
                            <span className="ms-1 fs-9 fw-bold">
                                Add Date
                            </span>
                        </span>

                    </FlexRow>
                    :
                    <div className={"row align-items-center mb-" + (props.marginBottom ?? 5)}>
                        {
                            props.label &&
                            <label className={"col col-12 " + (props.labelUp ? "mb-1" : (props.block ? "col-md-3" : "col-md-2")) + " fs-7"} htmlFor={props.id}>
                                {props.label}
                                {
                                    props.labelUp && !props.noTextError && <span id={props.name + "-err"} className="small text-danger mx-3 form-error"></span>
                                }
                            </label>
                        }

                        <div className={"col col-12 " + (props.labelUp ? "" : (props.block && props.label ? "col-md-9" : props.block ? "col-md-12" : "col-md-6"))}>
                            <div className={(props.icon) ? inputGroupClassName() : ""} style={{
                                position: "relative"
                            }}>
                                {
                                    props.icon &&
                                    <span className="input-group-text">
                                        <Icon icon={props.icon} />
                                    </span>
                                }
                                <input
                                    id={props.id}
                                    type="text"
                                    autoComplete="one-time-code"
                                    readOnly
                                    placeholder={props.placeholder}
                                    value={selectedDateString}
                                    className={className()}
                                />

                                {
                                    selectedDateString && selectedDateString != "" && !props.preventClear &&
                                    <a href="#" style={{
                                        position: "absolute",
                                        right: 16,
                                        top: "25%"
                                    }} onClick={e => {
                                        e.preventDefault();
                                        selectedDateSet(undefined);
                                        selectedDateStringSet("");
                                        selectedDateValStringSet("");
                                        if (props.onClear) props.onClear();
                                    }}>
                                        <Icon icon="times" color="#5e6278" size={14} />
                                    </a>
                                }

                                <input type="hidden" name={props.name} value={selectedDateValString} />
                                <input type="hidden" name={props.name + "Start"} value={selectedStartDateString} />
                                <input type="hidden" name={props.name + "End"} value={selectedEndDateString} />

                            </div>
                        </div>

                        {
                            !props.labelUp && !props.noTextError &&
                            <div className="col col-md-4">
                                <span id={props.name + "-err"} className="small text-danger mx-2 form-error"></span>
                            </div>
                        }

                    </div>
            }

        </>
    )
}